module.exports = __webpack_public_path__ + "static/media/Frame.9ef18cf0.png";